<style lang="scss">
  @use "../../assets/css/design-system/colors";

  button {
    &:not([disabled]),
    &[disabled="false"] {
      cursor: pointer;
    }

    outline: none;
    padding: 0;
    border: none;
    background: transparent;

    &:focus {
      outline: 2px solid colors.get(primary_50);
    }
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

<script>
  let {
    children,
    focus = $bindable(),
    onfocus: _onfocus,
    onblur: _onblur,
    onmouseenter: _onmouseenter,
    onmouseleave: _onmouseleave,
    ...restProps
  } = $props();
  import { getPureButtonContext } from "./pureButtonContext.svelte";

  const ctx = getPureButtonContext();

  const onfocus = (e) => {
    if (ctx) {
      ctx.focused = true;
    }
    return _onfocus?.(e);
  };

  const onblur = (e) => {
    if (ctx) {
      ctx.focused = false;
    }
    return _onblur?.(e);
  };

  const onmouseenter = (e) => {
    if (ctx) {
      ctx.hovered = true;
    }
    return _onmouseenter?.(e);
  };

  const onmouseleave = (e) => {
    if (ctx) {
      ctx.hovered = false;
    }
    return _onmouseleave?.(e);
  };
</script>

<button {onfocus} {onblur} {onmouseenter} {onmouseleave} {...restProps}>
  {@render children()}
</button>
